// extracted by mini-css-extract-plugin
module.exports = {"container":"_11NYI","spacing":"_1r5ji","icon":"_35mP9","controls":"T6_PB","table":"_21mYr","paginationContainer":"_1RW3H","sortSelectContainer":"_3HSuo","separatorColumn":"_36Ke_"};